import { render, staticRenderFns } from "./DepositTab.vue?vue&type=template&id=4ad31846"
import script from "./DepositTab.vue?vue&type=script&lang=js"
export * from "./DepositTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports